import React from "react";
import { styled } from "@mui/material/styles";
import {
  Button,
  Dialog,
  DialogContent,
  TextField,
  IconButton,
  useMediaQuery,
  DialogTitle,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";

const BRAND = "#f05d32";
const BRAND_HOVER = "#d94e27";

const MyTextField = styled(TextField)(() => ({
  "& label.Mui-focused": {
    color: BRAND,
  },
  "& .MuiOutlinedInput-root": {
    bgcolor: "#fff",
    "& fieldset": {
      borderColor: "rgba(0,0,0,0.12)",
      borderRadius: "12px",
    },
    "&:hover fieldset": {
      borderColor: "rgba(240, 93, 50, 0.45)",
    },
    "&.Mui-focused fieldset": {
      borderColor: BRAND,
      borderWidth: 1.5,
    },
  },
}));

const MyDialogTitle = (props) => {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle
      sx={{
        m: 0,
        px: 3,
        py: 2,
        backgroundColor: BRAND,
        color: "#fff",
        display: "flex",
        alignItems: "center",
        position: "relative",
        fontWeight: 600,
        fontSize: { xs: 18, sm: 20 },
        letterSpacing: "0.01em",
      }}
      {...other}
    >
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: "50%",
            transform: "translate(0,-50%)",
            color: "#fff",
            "&:hover": {
              bgcolor: "rgba(255,255,255,0.15)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

export default function Address(props) {
  const { component } = props;
  const { open = false } = component.props;
  const fullScreen = useMediaQuery(useTheme().breakpoints.down("sm"));

  return (
    <Dialog
      onClose={() => component.props.setOpen(false)}
      fullScreen={fullScreen}
      open={open}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: { xs: 0, sm: "20px" },
          minWidth: { xs: "100%", sm: 440 },
          maxWidth: { sm: 480 },
          overflow: "hidden",
        },
      }}
    >
      <MyDialogTitle onClose={() => component.props.setOpen(false)}>
        {component.ucfirst("contact-form")}
      </MyDialogTitle>

      <DialogContent
        dividers
        sx={{
          p: { xs: 2.5, sm: 3 },
          bgcolor: "#fafafa",
          borderColor: "rgba(0,0,0,0.06)",
        }}
      >
        <Box
          sx={{
            bgcolor: "#fff",
            border: "1px solid rgba(0,0,0,0.06)",
            borderRadius: "16px",
            p: { xs: 2, sm: 2.5 },
          }}
        >
          <Box
            component="form"
            onSubmit={(e) => component.sendRequest(e)}
            sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}
          >
            <MyTextField
              variant="outlined"
              margin="dense"
              fullWidth
              label={component.ucfirst("fullname-textfield")}
              name="name"
              autoComplete="name"
              helperText={component.getData("error.fields.name")}
              value={component.getData("default.fields.name", "")}
              onChange={(e) => {
                component.setData({ "default.fields.name": e.target.value });
                component.deleteData("error.fields.name");
              }}
              error={component.dataExists("error.fields.name")}
            />
            <MyTextField
              variant="outlined"
              margin="dense"
              fullWidth
              label={component.ucfirst("email-textfield")}
              name="email"
              type="email"
              autoComplete="email"
              helperText={component.getData("error.fields.email")}
              value={component.getData("default.fields.email", "")}
              onChange={(e) => {
                component.setData({
                  "default.fields.email": e.target.value,
                });
                component.deleteData("error.fields.email");
              }}
              error={component.dataExists("error.fields.email")}
            />
            <MyTextField
              variant="outlined"
              margin="dense"
              fullWidth
              label={`${component.ucfirst("phone-textfield")} (${component.ucfirst(
                "optional",
              )})`}
              name="phone"
              type="tel"
              autoComplete="tel"
              helperText={component.getData("error.fields.phone")}
              value={component.getData("default.fields.phone", "")}
              onChange={(e) => {
                component.setData({
                  "default.fields.phone": e.target.value,
                });
                component.deleteData("error.fields.phone");
              }}
              error={component.dataExists("error.fields.phone")}
            />
            <MyTextField
              variant="outlined"
              margin="dense"
              fullWidth
              multiline
              minRows={3}
              label={component.ucfirst("message-textfield")}
              name="message"
              helperText={component.getData("error.fields.message")}
              value={component.getData("default.fields.message", "")}
              onChange={(e) => {
                component.setData({
                  "default.fields.message": e.target.value,
                });
                component.deleteData("error.fields.message");
              }}
              error={component.dataExists("error.fields.message")}
            />
            <Button
              type="submit"
              fullWidth
              sx={{
                mt: 1.5,
                py: 1.25,
                bgcolor: BRAND,
                borderRadius: "50px",
                border: `1px solid ${BRAND}`,
                color: "#fff",
                fontSize: 15,
                fontWeight: 600,
                textTransform: "none",
                boxShadow: "0 2px 8px rgba(240, 93, 50, 0.25)",
                "&:hover": {
                  bgcolor: BRAND_HOVER,
                  borderColor: BRAND_HOVER,
                  boxShadow: "0 4px 14px rgba(240, 93, 50, 0.35)",
                },
              }}
            >
              {component.ucfirst("submit-btn")}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
